import ProductImage from 'components/Product/ProductImage/ProductImage';

export default ProductImage;
